<template>
    <v-dialog content-class="v-dialog-movable" v-model="show_message" persistent :max-width="'800'">    
        <v-card>
        <v-card-title>
            <span class="headline primary_blue--text">Inmatic Links</span>
        </v-card-title>
        <v-card-text v-if="screen_data && screen_data.data">
            <div class="d-flex align-center flex-start">
                <v-text-field v-model="screen_data.newName"></v-text-field>
                <v-btn @click="creatNew()" :disabled="!screen_data.newName">Add</v-btn>
            </div>
            <v-data-table :items="screen_data.data" :headers="screen_data.headers" :loading="screen_data.loadingSetCurrent" class="elevation-1">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ item.name }}</td>
                        <td>
                            <v-icon :color="item.current ? 'green' : 'red'">
                                {{ item.current ? 'mdi-circle' : 'mdi-circle' }}
                            </v-icon>
                        </td>
                        <td>
                            <v-btn v-if="!item.current" :loading="screen_data.loadingSetCurrent" color="primary" @click="setCurrent(item)">
                                Set Current
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card-text>
        <v-card-actions class="pa-6">
            <v-btn color="primary" rounded outlined text class="primary-border px-4" @click="$emit('close-dialog')">Cerrar</v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {VueConnectorIdsScreenData} from "./VueConnectorIdsScreenData"
// import {ConnectorId} from "../domain/ConnectorId"
// import {MemoryConnectorIdRepository} from "../infra/MemoryRepositories"
import {ConnectorIdsScreen} from "../application/ConnectorIdsScreen"
import { mapGetters } from "vuex"
import { ApiConnectorIdRepository } from "./ApiConnectorIdRepository"
export default {
    name: "ConnectorIdsList",
    data() {
        const screen_data = new VueConnectorIdsScreenData();
        return {
            screen_data:screen_data,
            connectorComponent: undefined
        };
    },
    props: {
        show_message: {
            type: Boolean,
            required: true
        },
    
        
    },
    computed: {
        ...mapGetters({
            userData: 'me/userData',
      }),
    },
    async mounted() {
        let connector_ids_repo = new ApiConnectorIdRepository()
        // let connector_id1 = new ConnectorId('a',1,'green',false);
        // let connector_id2 = new ConnectorId('b',2,'blue',false);
        // let connector_id3 = new ConnectorId('c',1,'blue',true);
        // let connector_id4 = new ConnectorId('d',1,'red',false);
        // let connector_ids_repo = new MemoryConnectorIdRepository([connector_id1.clone(), connector_id2.clone(), connector_id3.clone(), connector_id4.clone()])
        this.connectorComponent = new ConnectorIdsScreen(connector_ids_repo, this.screen_data, this.userData.id)
        await this.connectorComponent.fetch_all_connector_ids(this.userData.id)
    },
    methods: {
        async setCurrent(connector) {
            await this.connectorComponent.set_current_connector(this.userData.id, connector.name)
        },
        async creatNew() {
            await this.connectorComponent.set_current_connector(this.userData.id, this.screen_data.newName)
        }
    }
    
};
</script>

<style scoped>

::v-deep .v-card__title {
    padding-top: 15px !important;
    padding-bottom: 15px !important;

}
.card-title-footer-color {
    background: #fafaff;
}

::v-deep .v-data-footer {
    background-color: #fafaff;
    margin-right: 0px !important;
    padding-right: 17px;
}

::v-deep .v-data-table-header>tr>th {
    background-color: var(--v-primaryLight-base) !important;
}

::v-deep .v-data-table-header>tr>th>span,
::v-deep .v-data-table-header>tr>th>div>div>div>label>span {
    color: var(--v-primary-base);
    font-size: 0.875rem;
}

.font-color {
    color: #56565b;
}

::v-deep .v-data-table__wrapper>table>tbody>tr>td {
    border-bottom: none !important;
}

::v-deep tbody tr:nth-of-type(even) {
    /* 'deep-orange lighten-5' basides on material design color */
    background-color: rgba(245, 245, 245, 0.47);
}

::v-deep .v-input__prepend-inner>div>i {
    color: var(--v-primary-base);
    top: 2px;
    padding-left: 5px;
}

.text-field-size {
    font-weight: normal;
    font-size: 0.875rem;
}

::v-deep .input-search .v-input__slot::before {
    border-style: none !important;
}

::v-deep .input-search .v-text-field__slot,
::v-deep .input-search .v-input__prepend-inner,
::v-deep .input-search .v-input__slot {
    background-color: #f2f1ff !important;
}

::v-card-title .title-dialog {
    justify-content: space-around;
}

.autocomplete_field {
    border: solid 1px;
    border-color: var(--v-primary-base);
    color: transparent !important;
    height: 50px !important;
    margin: 0;
    padding: 0;
}

.acction_btns {
    display: flex !important;
    justify-content: space-between !important;
    padding: 0 36px 20px;
}

.cancel_button {
    border: 1px solid var(--v-primary-base);
    background-color: white !important;
    color: var(--v-primary-base);
    padding: 20px !important;
    font-size: 20px;
    text-transform: none !important;
}

.accept_button {
    border: 1px solid var(--v-primary-base);
    background-color: var(--v-primary-base) !important;
    color: white;
    padding: 20px !important;
    font-size: 20px;
    text-transform: none !important;
}

.btn-right {
    display: flex;
    justify-content: flex-end;
}

.no-underline>>>.v-text-field .v-input__control>.v-input__slot:before {
    border: none;
}
.rounded-10 {
    border-radius: 10px !important;
}

</style>